import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { slider } from 'src/app/models/slider';
import { DataService } from 'src/app/Services/data.service';

@Component({
  selector: 'app-slider-detay',
  templateUrl: './slider-detay.component.html',
  styleUrls: ['./slider-detay.component.css']
})
export class SliderDetayComponent implements OnInit {

  slider:slider = new slider();
  constructor(private dataServices:DataService,
    private route:ActivatedRoute
    ) { 


    }

 ngOnInit(): void {

    this.route.paramMap.subscribe(params=>{

     this.slider.sli_uid  = params.get("sliderId");

     this.getDetaySlider();

   }) 

 }

 getDetaySlider()
 {    

    this.dataServices.getSliderDetay(this.slider).subscribe(p=>{ 
     this.slider = p;        
    })

 }


}
